// App.jsx
import React from 'react';
import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ThemeSettings } from './theme/Theme';
import RTL from './layouts/full/shared/customizer/RTL';
import ScrollToTop from './components/shared/ScrollToTop';
import Router from './routes/Router';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { AuthProvider } from './guards/jwt/JwtContext';
import toast, { ToastBar, Toaster } from 'react-hot-toast';
import ReactHotToast from './components/ReactHotToast';

function App() {
  const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <RTL direction={customizer.activeDir}>
        
          <CssBaseline />
          <ScrollToTop>{routing}</ScrollToTop>
        </RTL>
      </ThemeProvider>
      <ReactHotToast>
                <Toaster
                  containerId='hot-toast-container'
                  position="top-center"
                  toastOptions={{ className: 'react-hot-toast' }}
                >
                  {t => (
                    <Box sx={{ cursor: 'pointer' }} onClick={() => toast.dismiss(t.id)}>
                      <ToastBar toast={t} />
                    </Box>
                  )}
                </Toaster>
              </ReactHotToast>
    </AuthProvider>
  );
}

export default App;